import { useEffect } from "react";
import GTM from "./gtm";

const usePageView = (pageTitle: string) => {
  useEffect(() => {
    GTM.pageView({
      page_location: window.location.href,
      page_title: pageTitle,
    });
  }, [pageTitle]);
};

export default usePageView;
